import './PartyPackageMenu.css';
import  { useState, useMemo } from 'react';
import { RiCheckboxBlankCircleLine } from "react-icons/ri";
import { API_BASE_URL } from '../../utils';
import { fi } from 'date-fns/locale';
import Beer  from '../image/Beer.png';
import Cocktail  from '../image/Cocktail.png';
import Gin  from '../image/Gin.png';
import Rum  from '../image/Rum.png';
import Tequila  from '../image/Tequila.png';
import Vodka  from '../image/Vodka.png';
import Whiskey  from '../image/Whiskey.png';
import WhiteWine  from '../image/WhiteWine.png';
import sparkling_wine  from '../image/sparkling_wine.png';
import rose_wine  from '../image/rose_wine.png';
import red_wine  from '../image/red_wine.png';
import champagne  from '../image/champagne.png';


export default function ClubMenuCards({ menus = [] }) {
    const [selectedCategory, setSelectedCategory] = useState('All');

    const menuData = menus.length > 0 ? menus[0].category : {};

    // Define default images for each category
    const categoryImages = {
        // Veg categories
        soups: "https://images.unsplash.com/photo-1611068120813-eca5a8cbf793?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        starter: "https://images.unsplash.com/photo-1632433796615-0ae72b6ab1b5?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fHN0YXRlciUyMGZvb2R8ZW58MHx8MHx8fDA%3D",
        maincourse: "https://images.unsplash.com/photo-1599904191183-015402e01e82?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWFpbiUyMGNvdXJzZSUyMHZlZyUyMHBhbmVlciUyMGZvb2R8ZW58MHx8MHx8fDA%3D",
        rice: "https://images.unsplash.com/photo-1596560548464-f010549b84d7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8cmljZSUyMGZvb2R8ZW58MHx8MHx8fDA%3D",
        breads: "https://images.unsplash.com/photo-1586026779826-a5205f0ff4e0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fGJyZWFkJTIwZm9vZHxlbnwwfHwwfHx8MA%3D%3D",
        desserts: "https://images.unsplash.com/photo-1661985887301-65bbb5a28b94?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8RGVzc2VydHMlMjBmb29kfGVufDB8fDB8fHww",
        
        // Non-veg categories  
        nonveg_soups: "https://images.unsplash.com/photo-1627880872609-f7ddd76616c2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGNoaWNrZW4lMjBTb3VwcyUyMG5vbiUyMHZlZyUyMGZvb2R8ZW58MHx8MHx8fDA%3D",
        nonveg_starter: "https://images.unsplash.com/photo-1616811625651-07a1268d769f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGNoaWNrZW4lMjBTdGFydGVycyUyMG5vbnZlZyUyMGZvb2R8ZW58MHx8MHx8fDA%3D",
        nonveg_maincourse: "https://images.unsplash.com/photo-1597577652129-7ffad9d37ad4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzJ8fGNoaWNrZW4lMjBTdGFydGVycyUyMG5vbnZlZyUyMGZvb2R8ZW58MHx8MHx8fDA%3D",
        nonveg_rice: "https://images.unsplash.com/photo-1628606338096-686cf7dba76a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mzl8fGJpcnlhbmklMjBTdGFydGVycyUyMG5vbnZlZyUyMGZvb2R8ZW58MHx8MHx8fDA%3D",
        nonveg_desserts: "https://images.unsplash.com/photo-1661985887301-65bbb5a28b94?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8RGVzc2VydHMlMjBmb29kfGVufDB8fDB8fHww",
        
        // Drinks categories
        whiskey: Whiskey,
        vodka: Vodka,
        rum: Rum,
        gin: Gin,
        tequila: Tequila,
        beer: Beer,
        cocktails: Cocktail,
        white_wine: WhiteWine,
        sparkling_wine:sparkling_wine,
        rose_wine:rose_wine,
        red_wine:red_wine,
        champagne:champagne,
        mocktails: "https://images.unsplash.com/photo-1527761939622-9119094630cf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8bW9ja3RhaWxzfGVufDB8fDB8fHww",
        soft_drinks: "https://images.unsplash.com/photo-1629059042675-ce386c84cebf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fHNvZnQlMjBkcmlua3N8ZW58MHx8MHx8fDA%3D",
        juice: "https://images.unsplash.com/photo-1603569283847-aa295f0d016a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8SnVpY2V8ZW58MHx8MHx8fDA%3D"
    };

    // Function to get category-specific image
    const getCategoryImage = (category, isVeg = true) => {
        const categoryKey = category.toLowerCase();
        
        // For veg items, use original category key
        if (isVeg) {
            return categoryImages[categoryKey] || "https://images.unsplash.com/photo-1712757248842-04f6e3844374?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTExfHx2ZWclMjBmb29kJTIwaW5kaWFufGVufDB8fDB8fHww";
        } else {
            // For non-veg items, use "nonveg_" prefix
            return categoryImages[`nonveg_${categoryKey}`] || "https://images.unsplash.com/photo-1680529672551-16132239d69b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDN8fHxlbnwwfHx8fHw%3D";
        }
    };

    const categories = useMemo(() => {
        const validCategories = Object.entries(menuData)
            .filter(([key, items]) => {
                if (key === 'clubLogo' || key === 'category') return false;
                
                const vegCount = parseInt(items?.veg_choice || items?.veg?.length || "0");
                const nonVegCount = parseInt(items?.nonveg_choice || items?.nonveg?.length || "0");
                const itemCount = parseInt(items?.item_choice || items?.item?.length || "0");

                // Check if this category has any valid data to show
                const hasVegData = items?.veg?.length > 0 && vegCount > 0;
                const hasNonVegData = items?.nonveg?.length > 0 && nonVegCount > 0;
                const hasItemData = !items?.veg && !items?.nonveg && items?.item?.length > 0 && itemCount > 0;
                
                // Only include category if it has at least one section with data
                return hasVegData || hasNonVegData || hasItemData;
            })
            .map(([key]) => key);
        return ['All', ...validCategories];
    }, [menuData]);

    const filteredMenus = useMemo(() => {
        const entries = Object.entries(menuData).filter(([key, items]) => {
            if (key === 'clubLogo' || key === 'category') return false;
            
            const vegCount = parseInt(items?.veg_choice || items?.veg?.length || "0");
            const nonVegCount = parseInt(items?.nonveg_choice || items?.nonveg?.length || "0");
            const itemCount = parseInt(items?.item_choice || items?.item?.length || "0");

            // Check if this category has any valid data to show
            const hasVegData = items?.veg?.length > 0 && vegCount > 0;
            const hasNonVegData = items?.nonveg?.length > 0 && nonVegCount > 0;
            const hasItemData = !items?.veg && !items?.nonveg && items?.item?.length > 0 && itemCount > 0;
            
            // Only include category if it has at least one section with data
            return hasVegData || hasNonVegData || hasItemData;
        });

        if (selectedCategory === 'All') return entries;
        return entries.filter(([key]) => key === selectedCategory);
    }, [selectedCategory, menuData]);


  const showTagForCategory = (category) => {
        const allowed = ['starter', 'maincourse'];
        return allowed.includes(category.toLowerCase());
    };

    return (
        <div className="cmc-gallery-empty-container">
            {!menus || menus.length === 0 || !menus[0]?.category || filteredMenus.length === 0 ? (
                <div className="cmc-gallery-empty-content">
                    <h1>No Menu Cards Available</h1>
                    <p>We're working on an exciting menu to give you the best value and experience.</p>
                    <img
                        src="https://illustrations.popsy.co/gray/web-design.svg"
                        alt="Coming Soon"
                        className="cmc-gallery-empty-image"
                    />
                </div>
            ) : (
                <div className="cmc-gallery-container">
                    <div className="cmc-gallery-filters">
                        {categories.map((cat, i) => (
                            <span
                                key={i}
                                className={`cmc-filter-button ${selectedCategory === cat ? 'cmc-active' : ''}`}
                                onClick={() => setSelectedCategory(cat)}
                            >
                                {cat.replace(/_/g, ' ').toUpperCase()}
                            </span>
                        ))}
                    </div>

                    <div className="cmc-gallery-content">
                        {filteredMenus.map(([category, items], index) => {
                            const formatCategory = category.replace(/_/g, ' ').toUpperCase();
                            const vegCount = parseInt(items?.veg_choice || items?.veg?.length || "0");
                            const nonVegCount = parseInt(items?.nonveg_choice || items?.nonveg?.length || "0");
                            const itemCount = parseInt(items?.item_choice || items?.item?.length || "0");

                            // Check if this category has any valid data to show
                            const hasVegData = items?.veg?.length > 0 && vegCount > 0;
                            const hasNonVegData = items?.nonveg?.length > 0 && nonVegCount > 0;
                            const hasItemData = !items?.veg && !items?.nonveg && items?.item?.length > 0 && itemCount > 0;
                            
                            // Only render category if it has at least one section with data
                            if (!hasVegData && !hasNonVegData && !hasItemData) {
                                return null;
                            }

                            return (
                                <div key={index} className="cmc-category-box">
                                    <div className="cmc-category-header">
                                        <h2>{formatCategory}</h2>
                                    </div>

                                    <div className="cmc-item-type-section">
                                        {/* VEG Section - Only show if vegCount > 0 and veg items exist */}
                                        {hasVegData && (
                                            <div className="cmc-type-box">
                                                {showTagForCategory(category) && <h3 className="cmc-type-title">Veg ({vegCount} Choices)</h3>
                                                }
                                                <div className="cmc-item-grid">
                                                    {items.veg.map((item, i) => (
                                                        <div key={`veg-${i}`} className="cmc-item-card veg">
                                                            <div className='cmc-veg-img-container'>
                                                                <img 
                                                                    src={getCategoryImage(category, true)} 
                                                                    alt={`${category} veg food`} 
                                                                />
                                                               {showTagForCategory(category) && <div className="cmc-tag">Veg</div>}
                                                            </div>
                                                            <div className='cmc-veg-text-container'>
                                                                <div className="cmc-item-text">{item}</div>
                                                               
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* NON-VEG Section - Only show if nonVegCount > 0 and nonveg items exist */}
                                        {hasNonVegData && (
                                            <div className="cmc-type-box">
                                                 {showTagForCategory(category) &&<h3 className="cmc-type-title">Non-Veg ({nonVegCount} Choices)</h3>
                                                }
                                                <div className="cmc-item-grid">
                                                    {items.nonveg.map((item, i) => (
                                                        <div key={`nonveg-${i}`} className="cmc-item-card nonveg">
                                                            <div className='cmc-veg-img-container'>
                                                                <img 
                                                                    src={getCategoryImage(category, false)} 
                                                                    alt={`${category} non-veg food`} 
                                                                />
                                                                {showTagForCategory(category) &&  <div className="cmc-tag">Non-Veg</div>}
                                                               
                                                            </div>
                                                            <div className='cmc-veg-text-container'>
                                                                <div className="cmc-item-text">{item}</div>
                                                              
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {/* ITEM Section - Only show if itemCount > 0 and item items exist */}
                                        {hasItemData && (
                                            <div className="cmc-type-box">
                                                 {showTagForCategory(category) &&
                                                <h3 className="cmc-type-title">Items ({itemCount} Choices)</h3>
                                                }
                                                <div className="cmc-item-grid">
                                                    {items.item.map((item, i) => (
                                                        <div key={`item-${i}`} className="cmc-item-card other">
                                                            <div className='cmc-veg-img-container'>
                                                                <img 
                                                                    src={getCategoryImage(category)} 
                                                                    alt={`${category} item`} 
                                                                />
                                                                {/* <div className="cmc-tag">Item</div> */}
                                                            </div>
                                                            <div className='cmc-veg-text-container'>
                                                                <div className="cmc-item-text">{item}</div>
                                                              
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}